module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/modals/confirm-text-modal/confirm-text-modal.component.scss
// module id = ./src/app/components/tools/modals/confirm-text-modal/confirm-text-modal.component.scss
// module chunks = main